import styled from "styled-components";
import { mediaQuery, transitionAll, headerSidePadding, SMALLER_MOBILE } from "@util/constants";

export const TopHeaderWrapper = styled.div<{
  availableTopNote: boolean;
  insanityHeader: boolean;
  productRecall: boolean;
}>`
  background-color:#fff;
  padding:10px ${headerSidePadding}px 10px ${headerSidePadding}px;
  display:flex;
  ${({ availableTopNote }) => availableTopNote ? `justify-content: space-between` : `justify-content: flex-end`};
  ${({ insanityHeader }) => insanityHeader && `justify-content: space-between`};
  ${({ productRecall }) => productRecall ? `justify-content: flex-end` : `justify-content: space-between `};

  ${mediaQuery.mediumDown}{
    ${({insanityHeader}) => insanityHeader ? `justify-content: space-between` : `justify-content: center`};
    ${({ productRecall }) => productRecall ? `justify-content: center` : `justify-content: space-between `};
  }
  .product-recall-container {
    font-size: 15px;
    line-height: 18px;
    display: flex;
    @media (max-width: 576px) {
      display: inline-block;
    }
  }
  @media only screen and (max-width: ${SMALLER_MOBILE}px) {
    padding:10px 20px 10px 20px;
  } 
`

export const TopText = styled.div`
  font-size:15px;
`

export const RegionDropdownNav = styled.nav<{
  statusDropdown: boolean;
}>`
  font-size:15px;
  ${mediaQuery.mediumDown}{
    justify-content: center;
  }
  a{
    span{
      text-decoration:none;
    }
  }
  button{
    background-color:transparent;
    border:none;
    display:flex;
    justify-content:space-between;
    padding:0 0 0 35px;
    align-items:center;
    cursor: pointer;
    ${transitionAll}
    span{
      margin-right:15px;
      @media only screen and (max-width: ${SMALLER_MOBILE}px) {
        font-size:15px;
      }
    }
    &:hover{
      opacity:.5 ;
    }
    svg{
      ${transitionAll}
      ${({ statusDropdown }) => statusDropdown && `transform: rotate(-180deg);`}
    }
  }
  ul{
    list-style-type:none;
  }
  > ul{
    .first-dropdown-wrapper{
      position:relative;

      .language-list {
        padding: 7.5px 15px 7.5px 35px;
        div{
          text-decoration:none;
        }
        &:first-child{
          padding-top:21px;
        }
        &:last-child{
          padding-bottom:21px;
        }
      }

      > ul{
        ${transitionAll}
        background:#fff;
        position:absolute;
        left:0;
        border-bottom-left-radius:3em;
        width:150%;
        top:calc(100% + 10px);
        z-index:20;
        ${mediaQuery.mediumDown}{
          width:120%;
        }
        a{
          padding:7.5px 15px 7.5px 35px;
          display:block;
          div{
            text-decoration:none;
          }
          &:hover{
            opacity:.5 ;
          }
        }
        li:first-child a{
          padding-top:21px;
        }
        li:last-child a{
          padding-bottom:21px;
        }
      }
    }
  }
  
`